import { render, staticRenderFns } from "./JDMatchingList.vue?vue&type=template&id=ba96bb0e&scoped=true&"
import script from "./JDMatchingList.vue?vue&type=script&lang=js&"
export * from "./JDMatchingList.vue?vue&type=script&lang=js&"
import style0 from "./JDMatchingList.vue?vue&type=style&index=0&id=ba96bb0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba96bb0e",
  null
  
)

export default component.exports